import * as React from "react";
import { Query } from "react-apollo";
import { Col } from "reactstrap";
import { FaInbox } from "react-icons/fa";

// GraphQL
import GetCompanyRequests from "../../../GraphQL/Queries/GetCompanyRequests";

// Presentation/UI
import Loader from "../../../Components/Loader/DotLoader";

// Theme
import { Colors } from "../../../Themes";

import styled from "@emotion/styled";

const SummaryContainer = styled.div`
  display: inline-block;
  & span {
    position: relative;
    top: 15px;
    left: 15px;
    font-size: 1.13em;
  }
  & span.summary-number {
    font-weight: 700;
    font-size: 1.73em;
  }
`;

class Requests extends React.Component<{ companyId: string }> {
  render() {
    const { companyId } = this.props;

    return (
      <Query query={GetCompanyRequests} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the requests</div>;
          }

          const requests = data.allRequests;
          const numberOfRequests =
            !requests || !requests.length ? 0 : requests.length;

          return (
            <Col xs={12} md={4} lg={4}>
              <SummaryContainer>
                <FaInbox size="4.75em" color={Colors.cmmsBlue} />
              </SummaryContainer>
              <SummaryContainer>
                <span className="summary-number">{numberOfRequests}</span>
                <br />
                <span>Customer Requests</span>
              </SummaryContainer>
            </Col>
          );
        }}
      </Query>
    );
  }
}

export default Requests;



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/DashboardCards/Requests.tsx